export default __webpack_public_path__ + "static/media/2021_Ke_and_Levine_2021_AmericanNaturalist.49b91f6e.pdf";